import * as generalTypes from '../types/generalTypes'

const initialState = {
  allOffers: null,
  activeOffers: [],
}

const discountReducer = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case generalTypes.VENDOR_OFFERS:
      // eslint-disable-next-line
      let active = payload?.activeOffers?.filter((data) => {
        return data.isActive === 'true' || data.isActive === 'TRUE'
      })
      return {
        ...state,
        allOffers: payload.allOffers,
        activeOffers: active,
      }
    default:
      return state
  }
}

export default discountReducer
